import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Chargeback } from '../types'
import { ChargebackListRequest, ChargebackListResponse } from './types'

export const chargebackListMounted = createEvent<ChargebackListRequest>()

export const deleteChargebackMounted = createEvent<{ id: number }>()

export const getChargebacks = fx<void, ChargebackListResponse>({
  method: 'GET',
  url: `/finance/chargeback`,
})

export const deleteChargeback = fx<void, void>({
  method: 'DELETE',
})

export const $chargebacks = restore<Chargeback[]>(
  getChargebacks.doneData.map((a) => a.body.items),
  [],
)

export const $chargebacksTotal = restore(
  getChargebacks.doneData.map((a) => a.body.total),
  0,
)

export const $totalAmountUsd = restore(
  getChargebacks.doneData.map((a) => a.body.totals.totalAmountUsd),
  0,
)

sample({
  clock: chargebackListMounted,
  fn: ({ limit, page, orderBy, orderDirection, where }) => {
    const query: Record<string, string> = {
      limit: String(limit),
      page: String(page),
    }

    if (orderBy) {
      query.order = `${orderDirection}${orderBy}`
    }

    if (Object.keys(where).length) {
      query.where = JSON.stringify(where)
    }

    return { query }
  },
  target: getChargebacks,
})

sample({
  clock: deleteChargebackMounted,
  fn: ({ id }) => ({ url: `/finance/chargeback/${id}` }),
  target: deleteChargeback,
})
